import { IntlShape } from "react-intl";
import type { CoreConnectIngredientOption } from "../../../api";


export const getCoreConnectIngredientLabel = (
  ingredient: CoreConnectIngredientOption,
  intl: IntlShape
): string =>
  [
    ingredient.text,
    ingredient.origin &&
      intl.formatMessage({
        id: `SUSTELL.GEOGRAPHY.${ingredient.origin.toUpperCase()}`,
      }),
    ingredient.productionYear,
  ]
    .filter(Boolean)
    .join(" - ");
